import React, { useState } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { updateMessages } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import Checkbox from 'apps/auth/components/form/Checkbox';
import Form from 'apps/auth/components/form-multi/Form';
import { PLUS_CHANGE_PLAN_FORM_NAME } from 'apps/auth/constants/formName';
import { URL_IMAGES_PAYSEND_PLUS } from 'apps/auth/constants/UrlConstants';
import { addZero, getDayMonthDate } from 'apps/auth/helpers/utils';
import { useExtra, useForm, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

import { GA_POCKET_TO_SUBSCRIPTION, CARD_TO_SUBSCRIPTION, ONE_MONTH_SUBSCRIPTION } from '../utils';

const Logo = styled.img`
    max-width: 100%;
`;

const Checkmark = styled.div`
    line-height: 1;
    margin-right: 18px;
`;

const PaysendPlusPlanChangePopup = (props) => {
    const [isChecked, setIsChecked] = useState(false);
    const {
        plusPrecheckTitle,
        month,
        threeMonths,
        paymentMethod,
        nextPaymentDate,
        endPaymentDate,
        plusPrecheckTerms,
        plusPrecheckButton,
        plusPrecheckCard,
        plusPrecheckAccount,
        defaultBankName,
    } = usePageMessages();
    const { lang } = useLanguage();
    const { subscriptionInfo } = useExtra();
    const { fields } = useForm(PLUS_CHANGE_PLAN_FORM_NAME);
    const isDisabled = !isChecked;
    const subscriptionEndDate = getDayMonthDate(subscriptionInfo.endPeriodTs, lang, 'long');

    const onSubmitHandler = (fields, json) => {
        props.popupRef.current?.close();
        if (json && json.messageBodyMessages) {
            props.updateMessages(json.messageBodyMessages);
        }
        if (json && json.redirectTo) {
            window.location.replace(json.redirectTo);
        }
    };
    const getNextPaymentDate = (subscriptionInfo, tariff = { id: ONE_MONTH_SUBSCRIPTION }) => {
        const jsDate = new Date(subscriptionInfo.endPeriodTs?.replace(/(\d{2}).(\d{2}).(\d{4})/, '$2/$1/$3'));
        const nextPaymentMonth = jsDate.getMonth() + (tariff.id === ONE_MONTH_SUBSCRIPTION ? 1 : 3);
        const newDate = new Date(jsDate.setMonth(nextPaymentMonth));
        return `${addZero(newDate.getDate())} ${newDate.toLocaleString(lang, { month: 'long' })}`;
    };

    const checkHandler = () => {
        setIsChecked(!isChecked);
    };

    const getPaymentMethodName = () => {
        if (subscriptionInfo.payMethodId === GA_POCKET_TO_SUBSCRIPTION) {
            return plusPrecheckAccount;
        } else if (subscriptionInfo.payMethodId === CARD_TO_SUBSCRIPTION) {
            return `${
                subscriptionInfo.addInfo?.payment_method_details?.bankName == null
                    ? defaultBankName
                    : subscriptionInfo.addInfo?.payment_method_details?.bankName + ' ' + plusPrecheckCard
            } ·· ${subscriptionInfo.addInfo?.payment_method_details?.pan}`;
        }
    };

    return (
        <Form
            id="change_plan_form"
            action={props.action}
            formName={PLUS_CHANGE_PLAN_FORM_NAME}
            validation={false}
            fields={fields}
            validateForm={false}
            getCanonicalPath={false}
            onSubmitHandler={onSubmitHandler}
        >
            <ComplexPopup
                primaryButtonType={'submit'}
                primaryButtonText={plusPrecheckButton}
                primaryButtonDisabled={isDisabled}
                primaryButtonForm={PLUS_CHANGE_PLAN_FORM_NAME}
                popupRef={props.popupRef}
                onPrimaryButtonClick={() => {
                    props.submitRef.current?.click();
                    props.popupRef.current?.close();
                }}
            >
                <Row indent="adaptive-32-48" textAlign={'center'}>
                    <Logo src={`${URL_IMAGES_PAYSEND_PLUS}/paysend-plus-logo.svg`} alt="plus-logo" />
                </Row>

                <Text color={'primary'} size={'main'} variant={'paragraph'} textAlign={'center'}>
                    {plusPrecheckTitle}
                </Text>

                <Text size={'header'} textAlign={'center'} variant={'div'} indent={'adaptive-24-32'}>
                    {`${props.tariff.amount} ${props.tariff.currencyCode} / ${props.tariff.id === ONE_MONTH_SUBSCRIPTION ? month : threeMonths}`}
                </Text>

                <Row indent={'adaptive-24-32'}>
                    <TableRow title={paymentMethod} pseudoTable>
                        {getPaymentMethodName()}
                    </TableRow>
                    <TableRow title={endPaymentDate} pseudoTable>
                        {subscriptionEndDate}
                    </TableRow>
                    <TableRow title={nextPaymentDate} pseudoTable>
                        {getNextPaymentDate(subscriptionInfo, props.tariff)}
                    </TableRow>
                </Row>

                <Row flex align={'center'}>
                    <Checkmark>
                        <Checkbox onChange={checkHandler} noValidation />
                    </Checkmark>
                    <Text color={'secondary'} size={'secondary'} variant={'div'}>
                        <DangerouslyHtml dangerouslyHtml={plusPrecheckTerms} />
                    </Text>
                </Row>
            </ComplexPopup>
            <Button type="submit" variant={'hidden'} />
        </Form>
    );
};

export default connect(null, { updateMessages })(PaysendPlusPlanChangePopup);
